/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect } from 'react';
import { Button, Tabs } from 'antd';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Spin } from 'shared/components';
import OverallTable from './OverallTable';
import CostTable from './CostTable';
import RevenueTable from './RevenueTable';
import ReportTable from './ReportTable';
import { HaierOrderTable as StyledHaierOrderTable } from './Styles';
import { FormValues } from './formValues.model';

const { TabPane } = Tabs;

interface HaierOrderTableProps {
  costingData: any;
}
const HaierOrderTable: React.FC<HaierOrderTableProps> = (props) => {
  const { costingData } = props;

  const validateSchema = yup.object().shape({
    costingId: yup.string().required(),
  });

  const methods = useForm<FormValues>({
    resolver: yupResolver(validateSchema),
    defaultValues: {
      _id: costingData.costingId || '',
    },
  });

  const { register, reset } = methods;

  useEffect(() => {
    reset({
      _id: costingData.costingId || '',
    });
  }, [costingData.costingId, reset]);

  useEffect(() => {
    register('_id');
  }, [register]);

  let content = <Spin />;
  if (costingData) {
    content = (
      <FormProvider {...methods}>
        <StyledHaierOrderTable>
          <Tabs defaultActiveKey="1" animated={false} destroyInactiveTabPane>
            <TabPane
              tab={
                <Button
                  shape="round"
                  style={{
                    height: 'fit-content',
                  }}
                >
                  ภาพรวม
                </Button>
              }
              key="1"
            >
              <OverallTable haierCostData={costingData} />
            </TabPane>
            <TabPane
              tab={
                <Button
                  shape="round"
                  style={{
                    height: 'fit-content',
                  }}
                >
                  รายจ่าย
                </Button>
              }
              key="2"
            >
              <CostTable haierCostData={costingData} />
            </TabPane>
            <TabPane
              tab={
                <Button
                  shape="round"
                  style={{
                    height: 'fit-content',
                  }}
                >
                  รายได้
                </Button>
              }
              key="3"
            >
              <RevenueTable haierCostData={costingData} />
            </TabPane>
            <TabPane
              tab={
                <Button
                  shape="round"
                  style={{
                    height: 'fit-content',
                  }}
                >
                  รายงาน
                </Button>
              }
              key="4"
            >
              <ReportTable haierCostData={costingData} />
            </TabPane>
          </Tabs>
        </StyledHaierOrderTable>
      </FormProvider>
    );
  }

  return content;
};

export default HaierOrderTable;
